<template>
  <document-container
      :header="[{
        type: 'Pagetitle',
        title: response.title,
        subtitle: response.subtitle,
        position: 'header',
        sort: 1,
        shared: true,
        documentType: 'ddf'
      }]"
      logo="https://www.dericon.DE/wp-content/uploads/2023/03/Dericon_Logo_990x230.png"
      documentType="ddf"
      v-if="response"
  >
    <div
        slot="raw-body"
        class="page-block"
        v-html="response.introduction.split('\n').join('<br>')"
    >
    </div>
    <div
        v-for="field in response.fields"
        slot="raw-body"
        class="page-block"
    >
      <div style="border-top: 1px solid #d4d4d4; padding-bottom: 10px;padding-top: 10px;">
        <table>
          <tr v-for="(entry, key) in field">
            <td style="width:120px;color:rgba(0,0,0,.5)">{{ translations[key][language] }}</td>
            <td v-if="key === 'mandatory'">
              <span
                  class="material-symbols-rounded"
                  :class="entry ? 'dericon-success' : 'dericon-error'"
                  style="font-size: 12px; vertical-align: sub;"
              >
                {{ entry ? 'check' : 'clear' }}
              </span>
            </td>
            <td v-else>{{ entry }}</td>
          </tr>
        </table>
      </div>


    </div>
    <div
        slot="raw-body"
        class="page-block"
    >
      <div class="pagebreak"></div>
    </div>

    <div
        slot="raw-body"
        class="page-block sample"
    >
      <h2>{{ this.translations.appendix[this.language] }}</h2>
      <h3>{{ this.translations.sample[this.language] }}</h3>
    </div>

    <div
        slot="raw-body"
        class="page-block sample"
    >
      <pre>{</pre>
    </div>

    <div
        slot="raw-body"
        class="page-block"
        style="padding-bottom: 0;"
        v-for="(entry, key, index) in response.sample"
    >
      <pre style="font-size:10px; padding-left:30px">{{key}}: {{ entry }}{{index !== Object.values(response.sample).length -1 ? ',':''}}</pre>
</div>

    <div
        slot="raw-body"
        class="page-block sample"
    >
      <pre>}</pre>
    </div>

  </document-container>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import TokenService
  from "../../service/TokenService"
import ProductService
  from "../../service/ProductService"

export default {
  name: 'ddf',
  props: ['language', 'type'],
  data() {
    return {
      token: null,
      response: null,
      typeMap: {
        "BONUS_CERTIFICATE_CAP": "Capped Bonus-Zertifikat",
        "DISCOUNT_CERTIFICATE_CLASSIC": "Discount-Zertifikat",
        "EXPRESS_CERTIFICATE_CLASSIC": "Express-Zertifikat",
        "EXPRESS_CERTIFICATE_FIX_COUPON": "Fix-Kupon Express-Zertifikat",
        "EXPRESS_CERTIFICATE_MEMORY": "Memory Express-Zertifikat",
        "REVERSE_CONVERTIBLE_CLASSIC": "Aktienanleihe",
      },
      translations: {
        appendix: {
          EN: 'Appendix',
          DE: 'Anhang',
        },
        sample: {
          EN: 'Sample',
          DE: 'Beispiel',
        },
        id: {
          EN: 'ID',
          DE: 'ID',
        },
        path: {
          EN: 'Path',
          DE: 'Pfad',
        },
        name: {
          EN: 'Name',
          DE: 'Name',
        },
        description: {
          EN: 'Description',
          DE: 'Beschreibung',
        },
        mandatory: {
          EN: 'Mandatory',
          DE: 'Erforderlich',
        },
        dataType: {
          EN: 'Data type',
          DE: 'Datentyp',
        },
        fieldRestriction: {
          EN: 'Field restriction',
          DE: 'Feld Einschränkung',
        },
        sampleValue: {
          EN: 'Sample value',
          DE: 'Beispielwert',
        },
      },
    }
  },

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/test/style/onepager.css`,
        },
        {
          rel: 'stylesheet',
          href: `https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded`,
        },
      ]
    },
  },

  mixins: [BlockMixin],

  computed: {
    logo() {
      return ['config', this.environment, 'images', 'logo.png'].join('/')
    },
  },

  methods: {},

  async created() {
    if (!this.$route.query.token) {
      this.token = await TokenService.checkToken()
    } else {
      this.token = this.$route.query.token
    }

    let response = await ProductService.getDdf(this.language, this.type, this.token)
    this.response = response.data
  },

  components: {
    DocumentContainer,
  },
}
</script>

<style lang="scss">
.ddf {
  font-size: 10px;

  .header {
    margin-top: 0 !important;
  }

  .logo {
    top: 47px !important;
  }

  td {
    border: none !important;
    padding: 1px 0 !important;
  }

  hr {
    position: relative;
    top: -11px;
    color: #d4d4d4
  }

  h1 {
    margin-top: .5em !important;
  }


  pre {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .page-block{
    padding-bottom: 0 !important;
  }

}
</style>



// WEBPACK FOOTER //
// Ddf.vue?11cc740b